import api from './api';
import { User } from './userService';

export interface LoginRequest {
  username: string;
  password: string;
}

export interface LoginResponse {
  token: string;
  refreshToken: string;
  permissions: string[];
}

export interface ChangePasswordRequest {
  currentPassword?: string;
  newPassword?: string;
  confirmNewPassword?: string;
}

export const authService = {
  async login(credentials: LoginRequest): Promise<LoginResponse> {
    // Use the centralized api instance. The base URL is already configured.
    const response = await api.post('/auth/login', credentials, {
      withCredentials: true
    });
    return response.data;
  },

  async getProfile(): Promise<User> {
    const response = await api.get('/auth/me');
    return response.data;
  },

  async changePassword(data: ChangePasswordRequest): Promise<void> {
    await api.post('/auth/change-password', data);
  }
};
